<template>
  <div class="sub-header">
      <span class="text">
        {{ 'EVhub ' + type.name + ' ' + orderSummary.Kleur }}
      </span>

    <span class="text">
        {{ orderSummary.Vermogen }}
      </span>

    <div class="type-image" v-if="!method.with_plugs">
      <div class="wrapper">
        <WcdSvg />
        <span class="text-black">WCD</span>
      </div>
    </div>
    <div v-else>
      <div class="wrapper">
        <img v-if="plug" :src="plug.image_url" alt="">
        <span class="text-black">
          <span class="strong">{{ plug.name }}</span>,
          {{ method.name }} {{ method.extra_name }}</span>
      </div>
    </div>

    <div class="system-wrapper" v-if="system.image || system.text">
      <img class="system-image" v-if="system.image" :src="system.image_url">
      <span class="text-black" v-text="system.text">Incl. 2 passen</span>
    </div>
  </div>
</template>

<script>
import WcdSvg from 'Components/../assets/icons/wcd.svg?inline';
import { mapGetters } from 'vuex';

export default {
  name: 'OrderPopupSubHeader',
  components: {
    WcdSvg,
  },
  computed: {
    ...mapGetters({
      orderSummary: 'build/getConfigurationSummary',
      type: 'types/current',
      method: 'methods/current',
      plug: 'methods/currentPlug',
    }),

    system() {
      return this.$store.getters['types/chosenProperty']('systems', this.$store.state.build.system);
    },
  },
};
</script>

<style scoped lang="scss">
.sub-header {
  display: flex;
  flex-direction: row;
  height: 60px;
  background-color: $highlight;
  padding: 0 36px 0 20px;
  align-items: center;
  justify-content: space-between;

  .type-image {
    display: flex;
    align-items: center;
    justify-content: space-between;

    img {
      width: 32px;
      height: 28px;
    }
  }

  .system-wrapper {
    display: flex;
    align-items: center;

    .system-image {
      max-width: 32px;
      max-height: 28px;
      margin-right: 5px;
    }
  }

  .wrapper {
    display: flex;
    align-items: center;

    .text-black {
      display: block;
      font-family: $font;
      font-size: 12px;
      color: #000;
      padding-left: 5px;

      .strong {
        font-family: $font-black;
      }
    }
  }

  .text {
    display: block;
    max-width: 50%;
    color: #196CAE;
    font-family: $font-black;
    font-size: 12px;

    &:last-child {
      width: 40%;
      margin-left: 32px;
    }
  }
}
</style>
